import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import { Scheme } from '.';

export const MenuLink = styled(NavLink)<{ scheme: Scheme }>`
  padding-left: 20px;
  height: 48px;
  box-sizing: border-box;
  color: ${(props) => props.scheme?.linkColor};
  font-size: 14px;
  width: 100%;
  text-decoration: none;
  &.active {
    background-color: ${(props) => props.scheme?.activeLinkBackground};
    color: ${(props) => props.scheme?.activeLinkColor};
    padding-left: 17px;
    border-left: solid 3px ${(props) => props.scheme?.activeLinkBorder};
  }
  &:not(.active):hover {
    background-color: ${(props) => props.scheme?.linkHoverBackground};
    color: ${(props) => props.scheme?.linkHoverColor};
  }
`;
